/*
 * RRP market currency conversion.
 *
 * RRP / "Est. retail" figures come from a product option (a raw number in the
 * shop's base currency), not a native Shopify price field, so Shopify Markets
 * never currency-converts them — the `money` filter only formats the number in
 * the active currency. This script converts those amounts at runtime using the
 * live storefront rate exposed at window.Shopify.currency.rate.
 *
 * It only acts when the active currency differs from the base (rate !== 1);
 * for the base-currency market the server-rendered values are already correct.
 *
 * Markup note: any US-only markup is baked into data-rrp-amount server-side, so
 * this file is currency-conversion only.
 *
 * Element contract:
 *   .js-rrp           -> data-rrp-amount (base major), data-rrp-prefix,
 *                        optional data-rrp-inline-disc="1" + data-rrp-price (converted cents)
 *   .js-rrp-disc      -> data-rrp-amount (base major), data-rrp-price (converted cents)
 *   .js-rrp-savings   -> data-rrp-total-base (base cents), data-rrp-total-native (converted cents),
 *                        data-rrp-subtotal (converted cents); toggles closest [data-rrp-savings-row]
 */
(function () {
  function currency() {
    return (window.Shopify && window.Shopify.currency) || null;
  }

  function getRate() {
    var c = currency();
    return c ? parseFloat(c.rate) : NaN;
  }

  function activeIso() {
    var c = currency();
    return c ? c.active : null;
  }

  function formatMoney(major) {
    var code = activeIso();
    // RRP figures always round UP to the next whole unit.
    var amount = Math.ceil(major);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return amount.toLocaleString();
    }
  }

  function setText(el, text) {
    // Guard against re-triggering the cart MutationObserver in a loop.
    if (el.textContent !== text) el.textContent = text;
  }

  function run(root) {
    // RRP conversion/markup is enabled for the US market only. All other markets
    // keep the server-rendered (unconverted) value.
    if (!window.__rrpUS) return;
    var rate = getRate();
    // rate === 1 (or missing) => active currency is the base currency; server output stands.
    if (!rate || !isFinite(rate) || rate === 1) return;
    root = root || document;

    root.querySelectorAll('.js-rrp').forEach(function (el) {
      var base = parseFloat(el.getAttribute('data-rrp-amount'));
      if (!isFinite(base)) return;
      var prefix = el.getAttribute('data-rrp-prefix') || '';
      var text = prefix + formatMoney(base * rate);

      if (el.getAttribute('data-rrp-inline-disc') === '1') {
        var priceCents = parseFloat(el.getAttribute('data-rrp-price'));
        var rrpCents = base * rate * 100;
        if (isFinite(priceCents) && rrpCents > 0) {
          var pct = Math.round(((rrpCents - priceCents) / rrpCents) * 100);
          if (pct > 0) text += ' (-' + pct + '%)';
        }
      }
      setText(el, text);
    });

    root.querySelectorAll('.js-rrp-disc').forEach(function (el) {
      var base = parseFloat(el.getAttribute('data-rrp-amount'));
      if (!isFinite(base) || base <= 0) return;
      var priceCents = parseFloat(el.getAttribute('data-rrp-price'));
      var rrpCents = base * rate * 100;
      var pct = isFinite(priceCents) ? Math.round(((rrpCents - priceCents) / rrpCents) * 100) : 0;
      setText(el, pct + '% off');
    });

    root.querySelectorAll('.js-rrp-savings').forEach(function (el) {
      var base = parseFloat(el.getAttribute('data-rrp-total-base')) || 0; // base cents
      var native = parseFloat(el.getAttribute('data-rrp-total-native')) || 0; // converted cents
      var sub = parseFloat(el.getAttribute('data-rrp-subtotal')) || 0; // converted cents
      var savings = (base * rate + native - sub) / 100;
      if (savings > 0) setText(el, formatMoney(savings));
      var row = el.closest('[data-rrp-savings-row]');
      if (row) row.style.display = savings > 0 ? '' : 'none';
    });
  }

  var cartObserver = null;
  function runFromCart() {
    if (cartObserver) cartObserver.disconnect();
    run(document);
    if (cartObserver) startObserving();
  }

  function startObserving() {
    var container =
      document.querySelector('[data-cart-line-items]') ||
      document.querySelector('.cart-items__wrapper');
    if (!container) return;
    var target = container.parentNode || container;
    cartObserver = cartObserver || new MutationObserver(function () {
      window.requestAnimationFrame(runFromCart);
    });
    cartObserver.observe(target, { childList: true, subtree: true });
  }

  function boot() {
    run(document);
    startObserving();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target || document);
  });

  window.rrpMarketConvert = run;
})();
